// extracted by mini-css-extract-plugin
export default {"deleteModal":"completion_deleteModal__nhC7O","tabsContainer":"completion_tabsContainer__FLfNy"};